import { useContext } from 'react';

import { WizardMultistepValue, WizardMultistepContext } from './WizardMultistepProvider';
import { WizardNavigationValue, WizardNavigationContext } from './WizardNavigationProvider';

export const useWizardMultistep = (): WizardMultistepValue => {
    const context = useContext(WizardMultistepContext);
    if (context === null) {
        throw new Error('useWizardMultistepState must be used within a WizardMultistepProvider');
    }
    return context;
};

export const useWizardNavigation = (): WizardNavigationValue => {
    const context = useContext(WizardNavigationContext);
    if (context === null) {
        throw new Error('useWizardNavigation must be used within a WizardNavigationProvider');
    }
    return context;
};
